import Swiper from 'swiper/core';
import { Navigation, Autoplay } from 'swiper/modules';

function initSliders() {
  const productSliders = document.querySelectorAll('.js-routes-slider');
  if (!productSliders.length) return;

  productSliders.forEach((slider) => {
    const sliderContainer = slider.closest('.js-slider-container');
    const sliderArrows = sliderContainer.querySelector('.js-arrows');
    let navArrows = false;
    if (sliderArrows) {
      const next = sliderArrows.querySelector('.js-arrow-next');
      const prev = sliderArrows.querySelector('.js-arrow-prev');
      navArrows = {
        nextEl: next,
        prevEl: prev,
      };
    }

    new Swiper(slider, {
      modules: [Autoplay, Navigation],
      slidesPerView: 'auto',
      grabCursor: true,
      // spaceBetween: 16,
      watchOverflow: true,
      centeredSlides: true,
      navigation: navArrows,
      breakpoints: {
        768: { slidesPerView: 1 },
        1024: { slidesPerView: 'auto' },
      },
      on: {
        init: function () {
          updateOpacity(this);
        },
        slideChange: function () {
          updateOpacity(this);
        },
      },
    });
  });

  function updateOpacity(swiperInstance) {
    swiperInstance.slides.forEach((slide) => {
      slide.style.opacity = '0.5';
    });
    const activeSlide = swiperInstance.slides[swiperInstance.activeIndex];
    if (activeSlide) activeSlide.style.opacity = '1';
  }
}

document.addEventListener('DOMContentLoaded', () => initSliders());

if (window.acf?.addAction) {
  const rerender = ($el) => initSliders($el[0] || $el);

  window.acf.addAction('render_block_preview', rerender);
  window.acf.addAction('render_block_preview_complete', rerender);
}
